export default "__VITE_ASSET__DQDrLrWX__"